<template>
  <v-card class="rsl-fixed-height">

    <v-container class="width-override">

      <v-form ref="theForm" v-if="formCount == 1" v-model="formValid" lazy-validation @submit.prevent>
        <v-form-base :model="formModel" :schema="deployedForm.forms[0]" @input="handleInput" />
        <v-spacer></v-spacer>
        <v-card flat v-if="filesAvailable && showUploadedFiles">
          <v-card-title>
            <v-btn
              small
              class="mr-2"
              color="primary"
              @click="showFiles = !showFiles"
            ><span v-if="!showFiles">{{ $t('CASES.TASKS.VIEW_TASK.BTNS.SHOW_FILES') }}</span><span v-if="showFiles">{{ $t('CASES.TASKS.VIEW_TASK.BTNS.HIDE_FILES') }}</span></v-btn>
          </v-card-title>
          <v-data-table v-if="showFiles"
            :headers="headers"
            :items="caseFiles"
            :items-per-page="10"
            item-key="ITEM_ID"
            sort-by="CREATED"
            :sort-desc="true"
            loading-text="Loading... Please wait"
          >
            <template slot="item.FILE_URL" slot-scope="row">
              <a :href="row.item.FILE_URL" target="_blank">{{ row.item.FILE_URL }}</a>
            </template>
            <template slot="item.actions" slot-scope="row">
              <v-btn
                v-if="row.item.IS_LOCAL"
                small
                class="mr-2"
                color="success"
                @click="downloadFile(row.item)"
              >
                {{ $t('GENERAL.BTNS.DOWNLOAD') }}
              </v-btn>
              <v-btn
                v-if="!row.item.IS_LOCAL"
                small
                class="mr-2"
                color="success"
                @click="openFile(row.item)"
              >
                {{ $t('GENERAL.BTNS.OPEN') }}
              </v-btn>
              <v-btn
                small
                class="mr-2"
                color="error"
                @click="deleteFile(row.item)"
              >
                {{ $t('GENERAL.BTNS.DELETE') }}
              </v-btn>
            </template>
          </v-data-table>

          <v-dialog
              transition="dialog-bottom-transition"
              max-width="400"
              v-model="deleteFileDialog"
              :retain-focus="false"
            >
            <template>
              <v-card>
                <v-toolbar
                  color="#f87723"
                  dark
                >{{ deleteFileTitle }}</v-toolbar>
                <v-card-text>
                  <div class="pt-5">{{ deleteFileText }}</div>
                  <div class="pt-5">{{ deleteFileName }}</div>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    text
                    @click="deleteFileDialog = false"
                  >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    @click="confirmDeleteFile()"
                  >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-card>
        <div id="marker"></div>
        <v-row
          class="custom-margin"
          align="center"
          justify="space-around"
        >
          <v-btn 
            depressed
            color="success"
            @click="saveForm(formModel, 'close')">
            {{ $t('GENERAL.BTNS.SAVE') }}
          </v-btn>
          <v-btn
            depressed
            color="secondary"
            @click="submitForm(formModel)"
            :loading="loading"
            :disabled="!formValid || disableSubmit"
          >
            {{ $t('GENERAL.BTNS.SUBMIT') }}
          </v-btn>
        </v-row>
      </v-form>

      <v-stepper v-if="formCount > 1" v-model="s1" class="grey lighten-2">
        <v-stepper-items>
          <v-stepper-content 
            v-for="form in deployedForm.forms" :key="form.group0.step"
            :step="form.group0.step">
            <v-form ref="theForm" v-model="formValid" lazy-validation @submit.prevent>
              <v-form-base :model="formModel" :schema="form" @input="handleInput" />
              <v-spacer></v-spacer>
              <v-card flat v-if="filesAvailable && showUploadedFiles" class="grey lighten-2">
                <v-card-title>
                  <v-btn
                    small
                    class="mr-2"
                    color="primary"
                    @click="showFiles = !showFiles"
                  ><span v-if="!showFiles">{{ $t('CASES.TASKS.VIEW_TASK.BTNS.SHOW_FILES') }}</span><span v-if="showFiles">{{ $t('CASES.TASKS.VIEW_TASK.BTNS.HIDE_FILES') }}</span></v-btn>
                </v-card-title>
                <v-data-table v-if="showFiles"
                  :headers="headers"
                  :items="caseFiles"
                  :items-per-page="10"
                  item-key="ITEM_ID"
                  sort-by="CREATED"
                  :sort-desc="true"
                  loading-text="Loading... Please wait"
                >
                  <template slot="item.FILE_URL" slot-scope="row">
                    <a :href="row.item.FILE_URL" target="_blank">{{ row.item.FILE_URL }}</a>
                  </template>
                  <template slot="item.actions" slot-scope="row">
                    <v-btn
                      v-if="row.item.IS_LOCAL"
                      small
                      class="mr-2"
                      color="success"
                      @click="downloadFile(row.item)"
                    >
                      {{ $t('GENERAL.BTNS.DOWNLOAD') }}
                    </v-btn>
                    <v-btn
                      v-if="!row.item.IS_LOCAL"
                      small
                      class="mr-2"
                      color="success"
                      @click="openFile(row.item)"
                    >
                      {{ $t('GENERAL.BTNS.OPEN') }}
                    </v-btn>
                    <v-btn
                      small
                      class="mr-2"
                      color="error"
                      @click="deleteFile(row.item)"
                    >
                      {{ $t('GENERAL.BTNS.DELETE') }}
                    </v-btn>
                  </template>
                </v-data-table>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="400"
                    v-model="deleteFileDialog"
                    :retain-focus="false"
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ deleteFileTitle }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ deleteFileText }}</div>
                        <div class="pt-5">{{ deleteFileName }}</div>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="deleteFileDialog = false"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          @click="confirmDeleteFile()"
                        >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>
              </v-card>
              <div id="marker2"></div>
              <v-row
                class="custom-margin"
                align="center"
                justify="space-around"
              >
                <v-btn
                  v-if="s1 <= formCount && s1 > 1 && currentPage != -1 && startPage != s1"
                  depressed
                  color="warning"
                  @click="backClick()"
                >
                  {{ $t('GENERAL.BTNS.BACK') }}
                </v-btn>

                <v-btn 
                  depressed
                  color="success"
                  @click="saveForm(formModel, 'close')">
                  {{ $t('GENERAL.BTNS.SAVE') }}
                </v-btn>

                <v-btn
                  v-if="s1 < formCount && s1 != finalPage"
                  depressed
                  color="secondary"
                  @click="continueForm(formModel)"
                  :disabled="!formValid || disableSubmit"
                >
                  {{ $t('GENERAL.BTNS.CONTINUE') }}
                </v-btn>

                <v-btn
                  v-if="s1 == formCount || s1 == finalPage"
                  depressed
                  color="secondary"
                  @click="submitForm(formModel)"
                  :loading="loading"
                  :disabled="!formValid || disableSubmit"
                >
                  {{ $t('GENERAL.BTNS.SUBMIT') }}
                </v-btn>
              </v-row>
            </v-form>
          </v-stepper-content>

        </v-stepper-items>
      </v-stepper>

    </v-container>

    <v-snackbar
      v-model="snack"
      :timeout="snackTimeout"
      :color="snackColor"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-if="!isErrorSnack"
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Close
        </v-btn>
        <v-btn
          v-if="isErrorSnack"
          v-bind="attrs"
          text
          @click="saveForm(formModel, 'close')"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

  </v-card>

  
</template>



<script>
  import $ from 'jquery';
  import VFormBase from 'vuetify-form-base';
  import { mapGetters } from 'vuex';

  // Helper & Partial Functions
  const required = msg => v => !!v || msg;

  export default {
    name: 'viewtask',
    components: {
      VFormBase
    },
    computed: {
      ...mapGetters(['storageDetails', 'taskId', 'formKey', 'processKey', 'processVersion', 'processName', 'instanceId', 'deployedForm', 'extScript', 'taskData', 'caseFiles', 'templateData', 'templateName', 'downloadFileUrl', 'downloadFileName', 'sqlData', 'mappedSqlData', 'errorMessage', 'allGroups', 'allUsersSpecial', 'qCount', 'taskName', 'caseId', 'allPortalUsers', 'apiReturnData', 'apiAuthCode', 'veridasResp', 'taskComplete', 'setCaseLabel']),
    },
    data: function() {
      return {
        formCount: 0,
        finalPage: null,
        s1: 1,
        currentPage: 0,
        startPage: 0,
        goToPage: 0,
        continueClicked: false,
        continueWasClicked: false,
        createPortalUser: false,
        portalUsername: '',
        portalPassword: '',
        formModel: {},
        formValid: true,
        validated: true,
        validateForm: false,
        continueFormData: [],
        currentData: null,
        currentObj: null,
        currentSchema: null,
        currentUser: this.$store.state.currentUser,
        currentUserFullname: this.$store.state.currentUserFullname,
        currentUserEmail: this.$store.state.currentUserEmail,
        allSchemas: [],
        jsScript: '',
        beforeQueries: [],
        afterQueries: [],
        duringQueries: [],
        singleQueries: [],
        queryCount: 0,
        autoCalc: [],
        runOnLoad: false,
        runOnce: true,
        loading: false,
        uploadFileCount: 0,
        uploadedFileCount: 0,
        uploadKey: null,
        uploadedKeys: [],
        showUploadedFiles: false,
        filesAvailable: false,
        deleteFileDialog: false,
        deleteFileTitle: '',
        deleteFileText: '',
        deleteFileName: '',
        deleteFileId: '',
        deleteFileGroupId: '',
        deleteLocalFile: false,
        theFileName: '',
        showFiles: false,
        pdfRequired: false,
        formGrids: {},
        headers: [
          { text: this.$t('DOCUMENTS.FIELDS.FILENAME'), align: 'start', sortable: true, value: 'FILE_NAME' },
          { text: this.$t('DOCUMENTS.FIELDS.SIZE'), value: 'FILE_SIZE', sortable: true },
          { text: this.$t('DOCUMENTS.FIELDS.CREATED_ON'), value: 'CREATED', sortable: true },
          { text: this.$t('DOCUMENTS.FIELDS.UPLOADED_BY'), value: 'UPLOADED_BY' },
          { text: this.$t('DOCUMENTS.FIELDS.ACTIONS'), value: 'actions', sortable: false }
        ],
        rules: {
          requiredText: required('This field is required'),
          requiredNumber: required('Please enter a value'),
          requiredSelect: required('Please make a selection'),
          requiredRadio: required('Please select an option'),
          requiredDate: required('Please select a valid date'),
          requiredTime: required('Please select a valid time'),
          requiredCheckbox: required('This checkbox is required'),
          requiredCheckboxAll: required('At least one checkbox must be selected'),
          requiredFile: required('Please select a file'),
          requiredEmail: required('Please enter a valid email address'),
          validEmail: v => /.+@.+\..+/.test(v) || 'The email address you entered is not valid'
        },
        snack: false,
        isErrorSnack: false,
        snackColor: '',
        snackText: '',
        snackTimeout: 3000,
        submitting: false,
        apiCall: false,
        externalApiLogin: false,
        apiPayload: [],
        veridas: false,
        veridasDocType: 'GB_DL',
        veridasValId: '',
        disableSubmit: false,
        refreshInterval: null,
        clearInterval: false,
        completeTaskData: {},
        runCompleteTask: false,
        caseLabel: '',
        reloadForm: false,
        cancelSubmit: false
      }
    },
    async created() {
      this.$store.commit('Q_COUNT', 0);
      let ref = this;
      this.unsubscribe = this.$store.subscribe((mutation) => {

        if(mutation.type === 'ERROR_MESSAGE') {
          this.snackErrorMessage();
        }

        if(mutation.type === 'API_DATA' || mutation.type === 'API_AUTH_CODE') {
          this.executeScript();
        }

        if(mutation.type === 'VERIDAS_RESP') {
          let payload = {};
          let vars = {};

          vars['veridasResp'] = { 'value': JSON.stringify(this.veridasResp), 'type': 'String' };

          payload['modifications'] = vars;
          let data = {
            'payload': payload,
            'instanceId': this.instanceId
          }
          this.$store.dispatch('saveTask', data).then( () => {
            this.disableSubmit = true;
            this.insertIframe(this.veridasResp.access_token, this.veridasResp.validation_id);
          });
        }
        
        if(mutation.type === 'RUN_SCRIPT' && (this.qCount == this.queryCount)) {
          if(this.extScript != '' && this.extScript !== null) {
            this.currentData = this.formModel;
            this.executeScript();
            // Check for goToPage
            if(this.goToPage > 0) {
              this.s1 = this.goToPage;
            }
          }
          this.queryCount = 0;
        }

        if(mutation.type === 'RUN_SCRIPT' && this.afterQueries.length > 0) {
          this.executeScript();
        }

        if (mutation.type === 'FILE_DATA_SAVED' || mutation.type === 'DELETED_FILE') {
          this.refreshTaskFiles();

          if(mutation.type === 'FILE_DATA_SAVED') {
            this.uploadedFileCount++;
            if(this.uploadFileCount == this.uploadedFileCount) {
              this.updateSchema(this.uploadKey);
              this.uploadFileCount = 0;
              this.uploadedFileCount = 0;
            }
          }
        }

        if(mutation.type === 'GRID_ROW_ADDED') {
          this.setGridCSS(100);

          // Remove previous click handlers
          $('.grid-delete-row').off();
          // Attach new click handlers
          $('.grid-delete-row').on('click', function() {
            let gname = $(this).attr('gname');
            let rowid = $(this).attr('rowid');
            ref.gridDeleteRow(gname, rowid);
          });
        }

        if(mutation.type === 'TASK_COMPLETE') {
          if(this.taskComplete) {
            this.clearInterval = true;
          }
        }

      });

      // Get all groups
      this.$store.dispatch('getAllGroups');
      // Get all users
      this.$store.dispatch('getAllUsersSpecial').then( () => {
        this.updateUsersGroups();
      });

      this.$store.dispatch('getStorageDetails');
      let data = {
        'formKey': this.formKey,
        'formAction': '',
        'processKey': this.processKey,
        'processVersion': this.processVersion
      }
      
      await this.$store.dispatch('getForm', data).then( async () => {
        this.formCount = this.deployedForm.forms.length;
        
        await this.$store.dispatch('getTaskData', this.instanceId).then( async () => {
          this.formModel = this.loadData();
          await this.$store.dispatch('getCaseFiles').then( () => {
            if(this.caseFiles.length > 0) {
              this.filesAvailable = true;
            }
          });

          if(this.runOnLoad) {
            if(this.extScript != '' && this.extScript !== null) {
              this.currentData = this.formModel;
              this.executeScript();
              // Check for goToPage
              if(this.goToPage > 0) {
                this.s1 = this.goToPage;
              }
            }
            this.runOnLoad = false;
          }

        });

      });

      // Add click events to file upload buttons
      let uploaders = document.querySelectorAll('.file-uploader');
      
      for(let i = 0; i < uploaders.length; i++) {
        uploaders[i].addEventListener("click", this.uploadFile);
      }

      // Add click events to grid add and delete buttons
      $('.grid-add-row').click(function() {
        let gname = $(this).attr('gname');
        ref.gridAddRow(gname);
      });

      // Add negative tabindex to icons
      let icons = document.querySelectorAll('.v-icon');
      
      for(let v = 0; v < icons.length; v++) {
        icons[v].setAttribute('tabindex', -1);
      }

      // Add colour class to v-cards
      let cards = document.getElementsByClassName('v-card');
      
      for(let c = 0; c < cards.length; c++) {
        cards[c].classList.add('grey', 'lighten-2');
      }

      // Add background to inputs
      let inputs = document.getElementsByClassName('v-input__slot');
      for(let p = 0; p < inputs.length; p++) {
        inputs[p].setAttribute('style', 'background-color: white; border-radius: 5px; padding: 10px;');
      }
      
      // Remove attributes for subforms if border is set
      let solidBorders = document.getElementsByClassName('subform-border-solid');
      
      for(let sb = 0; sb < solidBorders.length; sb++) {
        solidBorders[sb].classList.remove('grey', 'lighten-2');
      }

      let dashedBorders = document.getElementsByClassName('subform-border-dashed'); 
      
      for(let db = 0; db < dashedBorders.length; db++) {
        dashedBorders[db].classList.remove('grey', 'lighten-2');
      }
    },
    beforeDestroy() {
      this.unsubscribe();
    },
    mounted() {
      // Prevent enter key submitting the form
      $(document).ready(function() {
        $(window).keydown(function(event){
          if(event.keyCode == 13) {
            event.preventDefault();
            return false;
          }
        });
      });
      
      // Enables jQuery in browser window
      window.$ = window.jQuery = require('jquery');

      // Veridas iFrame listener
      let ref = this;
      window.addEventListener("message", receiveMessage, false);
      function receiveMessage(event) {
        if(event.origin.includes("xpressid")) {
          if(event.data.code == "ProcessCompleted") {
            if(ref.veridasValId == event.data.additionalData.validationId) {
              // Set the scores
              let scores = event.data.additionalData.globalScores;
              let ocr = event.data.additionalData.ocr.nodes;

              ref.saveScores(scores, ocr);
            }
          }
          if(event.data.type == "error") {
            ref.snack = true;
            ref.snackTimeout = 5000;
            ref.snackColor = 'error';
            ref.snackText = event.data.message + '. This page will reload in 5 seconds, please wait...';

            setTimeout(function(){ 
              window.location.reload(true);
            }, 5000);
          }
        }
      }

      // Check if task has already been completed - mainly for external tasks
      let refInt = this.$store.state.taskCompleteInt;
      if(this.$store.state.isLoggedIn && refInt == null) {
        this.autoCheckComplete();
      }

    },
    methods: {
      autoCheckComplete() {
        let ref = this;
        this.refreshInterval = setInterval(function () {
          if(!ref.clearInterval) {
            let payload = {
              'instanceId': ref.instanceId,
              'taskId': ref.taskId
            }
            ref.$store.dispatch('checkTask', payload);
          }
          if(!ref.$store.state.isLoggedIn || ref.clearInterval) {
            ref.stopAutoCheck();
          }
        }, 15000);
        this.$store.commit('setTaskCompleteInt', this.refreshInterval);
      },
      stopAutoCheck() {
        let refInt = this.$store.state.taskCompleteInt;
        clearInterval(refInt);
        this.$store.commit('setTaskCompleteInt', null);
        if(this.$store.state.isLoggedIn) {
          this.$router.push({ name: 'MyTasks' });
        }
      },
      userPassGen(charType) {
        // Declare all characters
        let str = '';
        let chars = '';
        let length = 8;

        if(charType == 'username') {
          chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

          // Generate ID
          for (let i = 0; i < length; i++) {
              str += chars.charAt(Math.floor(Math.random() * chars.length));
          }
        }

        if(charType == 'password') {
          length = 2;
          chars = 'abcdefghijklmnopqrstuvwxyz';

          // Generate ID
          for (let i = 0; i < length; i++) {
              str += chars.charAt(Math.floor(Math.random() * chars.length));
          }

          length = 1;
          chars = '!@$%^&*';

          // Generate ID
          for (let i = 0; i < length; i++) {
              str += chars.charAt(Math.floor(Math.random() * chars.length));
          }

          length = 1;
          chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

          // Generate ID
          for (let i = 0; i < length; i++) {
              str += chars.charAt(Math.floor(Math.random() * chars.length));
          }

          length = 1;
          chars = '0123456789';

          // Generate ID
          for (let i = 0; i < length; i++) {
              str += chars.charAt(Math.floor(Math.random() * chars.length));
          }

          length = 7;
          chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@$%^&*';

          // Generate ID
          for (let i = 0; i < length; i++) {
              str += chars.charAt(Math.floor(Math.random() * chars.length));
          }
        }

        return str;
      },
      createPortalUserNow() {
        this.$store.dispatch('getAllPortalUsers').then( () => {
          // Generate ID and PW
          let userId = this.userPassGen('username');
          let userPass = this.userPassGen('password');

          // Check if ID exists, if it does generate new ID
          let exists = false;
          for(let i = 0; i < this.allPortalUsers.length; i++) {
            if(this.allPortalUsers[i].id == userId) {
              exists = true;
              break;
            }
          }

          // If it doesn't exist, create user
          if(!exists) {
            this.portalUsername = userId;
            this.portalPassword = userPass;
          }else {
            this.createPortalUserNow();
          }
        });
      },
      updateUsersGroups() {
        let payload = {};
        let vars = {};

        vars['allUsersGroups'] = { 'value': JSON.stringify(this.allUsersSpecial), 'type': 'String' };

        payload['modifications'] = vars;
        let data = {
          'payload': payload,
          'instanceId': this.instanceId
        }
        this.$store.dispatch('saveTask', data);
      },
      setGridData() {
        // Populate grids if there are any defaults
        let ref = this;
        $('.grid-add-row').each(function() {
          let gname = $(this).attr('gname');
          if(ref.formModel[gname][0].items.length == 0) {
            ref.gridAddRow(gname);
          }
        });
        this.setGridDelete();
      },
      setGridDelete() {
        // Reset delete IDs
        let ref = this;
        setTimeout(function(){ 
          let gridDeleteRowBtns = document.querySelectorAll('.grid-delete-row');
          for(let i = 0; i < gridDeleteRowBtns.length; i++) {
            gridDeleteRowBtns[i].setAttribute('rowid', i);
          }
          ref.$store.commit('GRID_ROW_ADDED', true);
        }, 1500);
      },
      setGridCSS(time) {
        setTimeout(function(){ 
          let gridInputs = document.getElementsByClassName('v-input__slot');
          for(let g = 0; g < gridInputs.length; g++) {
            gridInputs[g].setAttribute('style', 'background-color: white; border-radius: 5px; padding: 10px;');
          }
        }, time);
      },
      buildSchema() {
        // Build the schema
        let schemaObj = {};
        for(let i = 0; i < this.allSchemas.length; i++) {
          let schemaKeys = Object.keys(this.allSchemas[i]);

          schemaKeys.forEach(key => {
            schemaObj[key] = this.allSchemas[i][key];
          });
        }
        this.currentSchema = schemaObj;
      },
      insertIframe(accessToken, validationId) {
        this.veridasValId = validationId;
        let src = 'https://xpressid-work.eu.veri-das.com?access_token=' + accessToken;
        let style = 'width:100%;height:100vh;';
        const iFrm = document.createElement('iframe');
        iFrm.setAttribute('id', 'XpressID-iframe');
        iFrm.setAttribute('allow', 'camera;microphone;');
        iFrm.setAttribute('style', style);
        iFrm.setAttribute('src', src);

        let el = '';
        if(this.formCount == 1) {
          el = document.getElementById('marker');
        }else {
          el = document.getElementById('marker2');
        }
        el.parentNode.insertBefore(iFrm, el);
      },
      saveScores(scores, ocr) {
        // Info
        let forename = '';
        let name = ocr[0].text.split(' ');
        let firstname = name[1].toLowerCase();
        firstname = firstname.charAt(0).toUpperCase() + firstname.slice(1);
        forename = firstname;

        if(name[2]) {
          let middlename = name[2].toLowerCase();
          middlename = middlename.charAt(0).toUpperCase() + middlename.slice(1);
          forename += ' ' + middlename;
        }

        let surname = ocr[1].text.toLowerCase();
        surname = surname.charAt(0).toUpperCase() + surname.slice(1);

        let fullname = forename + ' ' + surname;

        // Scores
        let proofOfLife = scores.biometryScores[0].value.toFixed(2);
        let selfieScore = scores.biometryScores[1].value.toFixed(2);
        let documentScore = scores.documentScores[0].value.toFixed(2);
        let integrityScore = scores.integrityScores[0].value.toFixed(2);
        let passBiometrics = '';

        if(documentScore < 0.50 || selfieScore < 0.50 || proofOfLife < 0.50) {
          passBiometrics = 'Fail';
        }else if((documentScore >= 0.50 && documentScore <= 0.70) || (selfieScore >= 0.50 && selfieScore <= 0.70) || (proofOfLife >= 0.50 && proofOfLife <= 0.70)) {
          passBiometrics = 'Review';
        }else {
          passBiometrics = 'Pass';
        }

        proofOfLife = (proofOfLife * 100).toFixed(2);
        selfieScore = (selfieScore * 100).toFixed(2);
        documentScore = (documentScore * 100).toFixed(2);
        integrityScore = (integrityScore * 100).toFixed(2);

        // Save the scores
        let payload = {};
        let vars = {};

        vars['passBiometrics'] = { 'value': passBiometrics, 'type': 'String' };
        vars['proofOfLife'] = { 'value': proofOfLife + '%', 'type': 'String' };
        vars['selfieScore'] = { 'value': selfieScore + '%', 'type': 'String' };
        vars['documentScore'] = { 'value': documentScore + '%', 'type': 'String' };
        vars['integrityScore'] = { 'value': integrityScore + '%', 'type': 'String' };
        vars['biometricsFullname'] = { 'value': fullname, 'type': 'String' };

        payload['modifications'] = vars;
        let data = {
          'payload': payload,
          'instanceId': this.instanceId
        }
        this.$store.dispatch('saveTask', data);
        this.disableSubmit = false;
        this.veridasValId = '';
      },
      executeScript() {
        if(this.currentObj == null) {
          this.currentObj = {};
        }

        if(this.currentSchema == null) {
          this.buildSchema();
        }
        
        if(this.currentData == null) {
          this.currentData = this.formModel;
        }
        
        let ref = this;
        setTimeout(function(){

          // Execute any autoCalc fields
          for(let i = 0; i < ref.autoCalc.length; i++) {
            let calc = "let data = ref.currentData;\ndata." + ref.autoCalc[i].field + " = " + ref.autoCalc[i].auto;
            eval(calc);
          }
          ref.autoCalc = [];
          ref.jsScript = `let obj = ref.currentObj;\nlet schema = ref.currentSchema;\nlet data = ref.currentData;\nlet currentPage = ref.s1;\nlet continueClicked = ref.continueClicked;\nlet goToPage = ref.goToPage;\nlet finalPage = ref.finalPage;\nlet users = ref.allUsersSpecial;\nlet groups = ref.allGroups;\nlet currentUser = ref.currentUser;\nlet currentUserFullname = ref.currentUserFullname;\nlet currentUserEmail = ref.currentUserEmail;\nlet runOnce = ref.runOnce;\nlet submitting = ref.submitting;\nlet apiCall = ref.apiCall;\nlet apiPayload = ref.apiPayload;\nlet apiReturnData = ref.apiReturnData;\nlet apiAuthCode = ref.apiAuthCode\nlet externalApiLogin = ref.externalApiLogin;\nlet caseId = ref.caseId;\nlet veridas = ref.veridas;\nlet veridasDocType = ref.veridasDocType;\nlet createPortalUser = ref.createPortalUser;\nlet caseLabel = ref.setCaseLabel;\nlet showUploadedFiles = ref.showUploadedFiles;\nlet reloadForm = ref.reloadForm;\nlet cancelSubmit = ref.cancelSubmit;\n`;
          ref.jsScript += ref.extScript;
          ref.jsScript += `\nref.goToPage = goToPage;\nref.finalPage = finalPage;\nref.apiCall = apiCall;\nref.apiPayload = apiPayload;\nref.externalApiLogin = externalApiLogin;\nref.veridas = veridas;\nref.veridasDocType = veridasDocType;\nref.createPortalUser = createPortalUser;\nref.caseLabel = caseLabel;\nref.showUploadedFiles = showUploadedFiles;\nref.reloadForm = reloadForm;\nref.cancelSubmit = cancelSubmit;`;
          eval(ref.jsScript);

          // Update form schema for this page and following page
          ref.updateSchemaForm(ref.s1 - 1);
          ref.updateSchemaForm(ref.s1);

          if(ref.caseLabel != '' && ref.caseLabel != ref.setCaseLabel) {
            let data = {
              'caseLabel': ref.caseLabel,
              'caseId': parseInt(ref.caseId)
            }
            ref.$store.dispatch('updateCaseLabel', data);
          }

          // API call, return data in apiReturnData
          if(ref.apiCall) {
            ref.$store.dispatch('fireApi', ref.apiPayload);
            ref.apiCall = false;
            ref.apiPayload = [];
          }

          // External login for API required
          if(ref.externalApiLogin) {
            ref.externalApiLogin = false;
            let target = ref.apiReturnData[0];
            window.open(target);
          }

          if(ref.veridas) {
            let data = {
              'mobileUrl': window.location.origin + '/external',
              'documentType': ref.veridasDocType,
              'mobileParams': '{ "fkey": "' + ref.formKey + '", "pkey": "' + ref.processKey + '", "v": "' + ref.processVersion + '", "extid": "' + ref.instanceId + '"}'
            }
            ref.$store.dispatch('veridasAuth', data);
            ref.veridas = false;
          }

          if(ref.validateForm || (ref.goToPage > 0 && ref.goToPage != ref.s1)) {
            if(ref.continueWasClicked) {
              if(ref.continueClicked) {
                ref.validate(ref.continueFormData);
              }else {
                ref.formValid = true;
              }
            }else {
              ref.validate(ref.continueFormData);
            }
          }

          if(ref.reloadForm) {
            ref.formReload();
            ref.reloadForm = false;
          }

          ref.continueClicked = false;
          ref.runOnce = false;
          ref.validateForm = false;
          ref.setGridCSS(1500);

          if(ref.runCompleteTask) {
            ref.$store.dispatch('completeTask', ref.completeTaskData).then( () => {
              ref.stopAutoCheck();
            });
          }

        }, 250);
      },
      formReload() {
        this.saveForm(this.formModel, 'reload');
      },
      evaluateSql(query) {
        // Replace variable names with values in query
        let stringIndex = 0;
        let intIndex = 0;
        let sqlIndex = 0;
        let theVar = '';
        let targetSql = query;

        // If it's an SQL insert/update command
        while(sqlIndex != -1) {
          sqlIndex = targetSql.indexOf('%{', sqlIndex);
          if(sqlIndex != -1) {
            sqlIndex += 2;
            theVar = targetSql.substring(sqlIndex, targetSql.indexOf('}', sqlIndex));
            let target = '%{' + theVar + '}';
            let replaceWith = '';
            if(typeof this.formModel[theVar] === 'undefined') {
              if(typeof this.taskData[theVar] === 'undefined') {
                replaceWith = null;
              }else {
                replaceWith = this.taskData[theVar].value;
              }
            }else {
              replaceWith = this.formModel[theVar];
            }
            let update = targetSql.replace(target, replaceWith);
            targetSql = update;
            sqlIndex++;
          }
        }

        // If it's a string
        while(stringIndex != -1) {
          stringIndex = targetSql.indexOf('${', stringIndex);
          if(stringIndex != -1) {
            stringIndex += 2;
            theVar = targetSql.substring(stringIndex, targetSql.indexOf('}', stringIndex));
            let target = '${' + theVar + '}';
            let replaceWith = '';
            if(typeof this.formModel[theVar] === 'undefined') {
              if(typeof this.taskData[theVar] === 'undefined') {
                replaceWith = null;
              }else {
                replaceWith = this.taskData[theVar].value.replaceAll("'", "''");
              }
            }else {
              replaceWith = this.formModel[theVar].replaceAll("'", "''");
            }
            let update = targetSql.replace(target, replaceWith);
            targetSql = update;
            stringIndex++;
          }
        }

        // If it's a number
        while(intIndex != -1) {
          intIndex = targetSql.indexOf('#{', intIndex);
          if(intIndex != -1) {
            intIndex += 2;
            theVar = targetSql.substring(intIndex, targetSql.indexOf('}', intIndex));
            let target = '#{' + theVar + '}';
            let replaceWith = this.formModel[theVar];
            if(typeof replaceWith === 'undefined' || replaceWith == '') {
              if(typeof this.taskData[theVar] === 'undefined') {
                replaceWith = null;
              }else {
                if(this.taskData[theVar].value == '') {
                  replaceWith = null;
                }else {
                  replaceWith = this.taskData[theVar].value;
                }
              }
            }
            let update = targetSql.replace(target, replaceWith);
            targetSql = update;
            intIndex++;
          }
        }
        
        return targetSql;
      },
      executeSql(query) {
        let targetSql = this.evaluateSql(query.sqlQuery);

        // Find out if query is a select or something else - temporary solution
        let queryType = targetSql.split(' ')[0];

        if(queryType.toLowerCase() == 'select') {
          let payload = {
            'connId': query.dbConnId,
            'theSql': targetSql,
            'mappedVar': query.sqlVar
          };
          this.$store.dispatch('executeSql', payload).then( () => {
            this.formModel[query.sqlVar] = this.mappedSqlData;
            this.saveForm(this.formModel, '');
          });
        }else {
          let payload = {
            'connId': query.dbConnId,
            'theSql': targetSql
          };

          this.$store.dispatch('executeSqlOther', payload).then( () => {
            this.saveForm(this.formModel, '');
          });
        }
      },
      executeFieldSql(query) {
        let targetSql = this.evaluateSql(query.sqlQuery);
        let payload = {
          'connId': query.dbConnId,
          'theSql': targetSql,
          'mappedVar': ''
        };
        this.$store.dispatch('executeSql', payload).then( () => {
          if(this.sqlData.length > 0) {
            // Get the keys form the SQL data
            const sqlKeys = Object.keys(this.sqlData[0]);
            // Select, Autocomplete fields
            if(query.type == 'select' || query.type == 'autocomplete') {
              if(typeof query.isGrid !== 'undefined' && query.isGrid) {
                this.deployedForm.forms[`${query.form}`][`${query.group}`].schema[`${query.theGrid}`].schema.items.schema[`${query.sqlVar}`].items = [];
                for(let s = 0; s < this.sqlData.length; s++) {
                  this.deployedForm.forms[`${query.form}`][`${query.group}`].schema[`${query.theGrid}`].schema.items.schema[`${query.sqlVar}`].items.push({ name: this.sqlData[s][sqlKeys[0]], val: this.sqlData[s][sqlKeys[1]] });
                }
              }else {
                this.deployedForm.forms[`${query.form}`][`${query.group}`].schema[`${query.sqlVar}`].items = [];
                for(let s = 0; s < this.sqlData.length; s++) {
                  this.deployedForm.forms[`${query.form}`][`${query.group}`].schema[`${query.sqlVar}`].items.push({ name: this.sqlData[s][sqlKeys[0]], val: this.sqlData[s][sqlKeys[1]] });
                }
              }
            }
            // Combobox field
            if(query.type == 'combobox') {
              if(typeof query.isGrid !== 'undefined' && query.isGrid) {
                this.deployedForm.forms[`${query.form}`][`${query.group}`].schema[`${query.theGrid}`].schema.items.schema[`${query.sqlVar}`].items = [];
                for(let s = 0; s < this.sqlData.length; s++) {
                  this.deployedForm.forms[`${query.form}`][`${query.group}`].schema[`${query.theGrid}`].schema.items.schema[`${query.sqlVar}`].items.push(this.sqlData[s][sqlKeys[0]]);
                }
              }else {
                this.deployedForm.forms[`${query.form}`][`${query.group}`].schema[`${query.sqlVar}`].items = [];
                for(let s = 0; s < this.sqlData.length; s++) {
                  this.deployedForm.forms[`${query.form}`][`${query.group}`].schema[`${query.sqlVar}`].items.push(this.sqlData[s][sqlKeys[0]]);
                }
              }
            }
            // Radio field
            if(query.type == 'radio') {
              this.deployedForm.forms[`${query.form}`][`${query.group}`].schema[`${query.sqlVar}`].options = [];
              for(let s = 0; s < this.sqlData.length; s++) {
                this.deployedForm.forms[`${query.form}`][`${query.group}`].schema[`${query.sqlVar}`].options.push({ label: this.sqlData[s][sqlKeys[0]], value: this.sqlData[s][sqlKeys[1]] });
              }
            }
            // Text, textarea, number and grid checkboxes fields
            if(query.type == 'text' || query.type == 'textarea' || query.type == 'number' || query.type == 'date' || query.type == 'time' || query.type == 'wrap') {
              if(typeof query.isGrid !== 'undefined' && query.isGrid) {
                for(let s = 0; s < this.sqlData.length; s++) {
                  this.formGrids[`${query.theGrid}`][`${query.sqlVar}`] = this.sqlData[s][sqlKeys[0]];
                }
              }else {
                for(let s = 0; s < this.sqlData.length; s++) {
                  this.formModel[`${query.sqlVar}`] = this.sqlData[s][sqlKeys[0]];
                }
              }
            }
            // Checkbox field
            if(query.type == 'checkbox') {
              if(typeof query.isGrid !== 'undefined' && query.isGrid) {
                for(let s = 0; s < this.sqlData.length; s++) {
                  this.formGrids[`${query.theGrid}`][`${query.sqlVar}`] = this.sqlData[s][sqlKeys[0]];
                }
              }else {
                let checkOptions = {};
                let options = {};
                let itemKeys = Object.keys(this.sqlData[0]);
                
                for(let s = 0; s < this.sqlData.length; s++) {
                  let checkLabel = '';
                  let checkVar = '';
                  let checkVal = false;

                  itemKeys.forEach((ikey) => {
                    if(typeof this.sqlData[s][ikey] == 'boolean') {
                      checkVal = this.sqlData[s][ikey];
                    }else {
                      // Remove accents and convert to lowercase
                      let varStr = this.sqlData[s][ikey];
                      // Remove accents
                      let normalised = varStr.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                      
                      // Replace any non-alphanumeric character with an empty string
                      // Then ensure it starts with a letter (for variable name compatibility)
                      normalised = (normalised.charAt(0).match(/[a-zA-Z]/) ? '' : '_') + 
                            normalised.replace(/[^a-zA-Z0-9]/g, '');

                      checkVar = normalised;
                      checkLabel = this.sqlData[s][ikey];
                    }
                  });

                  checkOptions[checkVar] = {
                    class: 'pl-8',
                    id: checkVar,
                    label: checkLabel,
                    parent: `${query.sqlVar}`,
                    prependIcon: '',
                    ripple: false,
                    type: 'checkbox',
                    col: { 'xs': 12, 'sm': 12, 'md': 2 },
                    value: checkVal
                  };

                  options[checkVar] = checkVal;
                }

                this.deployedForm.forms[`${query.form}`][`${query.group}`].schema[`${query.sqlVar}`].schema.items.schema = checkOptions;
                this.formModel[`${query.sqlVar}`] = [{'items': [options]}];
              }
            }
            // Subheader (paragraph) field
            if(query.type == 'subheader') {
              for(let s = 0; s < this.sqlData.length; s++) {
                document.getElementById(`${query.sqlVar}`).innerHTML = this.sqlData[s][sqlKeys[0]];
              }
            }
          }
        });
      },
      backClick() {
        if(this.goToPage > 0 && this.currentPage > 0) {
          this.s1 = this.currentPage;
        }else if(this.currentPage == 0) {
          this.s1 = 1;
        }else {
          this.s1 -= 1;
        }
        // Reset goToPage
        this.goToPage = 0;

        this.formValid = true;

        for(let i = 0; i < this.beforeQueries.length; i++) {
          if(this.beforeQueries[i].pageQueryNum == this.s1) {
            let runQuery = false;
            if(this.beforeQueries[i].sqlRunIf != '') {
              let query = "let data = this.currentData;\n" + this.beforeQueries[i].sqlRunIf;
              runQuery = eval(query);
            }else {
              runQuery = true;
            }
            // Runs on this page
            if(this.beforeQueries[i].beforeAfter == 'Before') {
              // Run now
              if(runQuery) {
                this.executeSql(this.beforeQueries[i]);
              }
            }
          }
          // Execute field queries
          for(let f = 0; f < this.duringQueries.length; f++) {
            this.executeFieldSql(this.duringQueries[f]);
          }
        }
      },
      loadData() {
        // Get the keys
        const keys = Object.keys(this.taskData);
        let data = {};
        let processedKeys = [];

        // Check if PDF generation is required
        if(this.deployedForm.forms[0].group0.pdfTemplateId) {
          this.pdfRequired = true;
        }

        // Evaluate SQL
        if(this.deployedForm.forms[0].group0.sqlQueries && this.deployedForm.forms[0].group0.sqlQueries !== null) {
          let numQueries = this.deployedForm.forms[0].group0.sqlQueries.length;
          let queries = this.deployedForm.forms[0].group0.sqlQueries;

          for(let q = 0; q < numQueries; q++) {
            let runQuery = false;
            if(queries[q].sqlRunIf != '') {
              let query = "let data = this.taskData;\n" + queries[q].sqlRunIf;
              runQuery = eval(query);
            }else {
              runQuery = true;
            }

            if(queries[q].pageQueryNum == this.s1) {
              // Runs on this page
              if(queries[q].beforeAfter == 'Before') {
                // Run now
                this.beforeQueries.push(queries[q]);
                if(runQuery) {
                  this.executeSql(queries[q]);
                }
              }else {
                // Add the rest to run on continue/submit
                this.afterQueries.push(queries[q]);
              }
            }else {
              // Add the rest to run on continue/submit
              this.afterQueries.push(queries[q]);
            }
          }
        }else {
          // Do nothing
        }
        
        let numForms = this.deployedForm.forms.length;
        
        for(let i = 0; i < numForms; i++) {

          let numGroups = Object.keys(this.deployedForm.forms[i]).length;
          
          for(let j = 1; j < numGroups; j++) {
            let group = 'group' + j;
            
            const groupKeys = Object.keys(this.deployedForm.forms[i][`${group}`]);
            
            groupKeys.forEach((gkey) => {
              // Run script on load
              if(gkey == 'runOnLoad') {
                if(this.deployedForm.forms[i][`${group}`][gkey]) {
                  this.currentSchema = this.deployedForm.forms[i][`${group}`].schema;
                  this.runOnLoad = true;
                }
              }
            });

            // Set current schema
            this.allSchemas.push(this.deployedForm.forms[i][`${group}`].schema);

            const schemaKeys = Object.keys(this.deployedForm.forms[i][`${group}`].schema);
            
            schemaKeys.forEach((skey) => {
              
              const itemKeys = Object.keys(this.deployedForm.forms[i][`${group}`].schema[skey]);
              
              itemKeys.forEach((ikey) => {
                
                // Evaluate auto calculation fields
                if(ikey == 'autocalc' && this.deployedForm.forms[i][`${group}`].schema[skey][ikey] !== null && this.deployedForm.forms[i][`${group}`].schema[skey][ikey] != '') {
                  let autoCalcField = {
                    field: skey,
                    auto: this.deployedForm.forms[i][`${group}`].schema[skey][ikey]
                  }
                  this.autoCalc.push(autoCalcField);
                }
                
                // Evaluate SQL fields
                if(ikey == 'fieldSql' && this.deployedForm.forms[i][`${group}`].schema[skey][ikey] !== null && this.deployedForm.forms[i][`${group}`].schema[skey][ikey] != '' && this.deployedForm.forms[i][`${group}`].schema[skey].type != 'array' && this.deployedForm.forms[i][`${group}`].schema[skey].type != 'date' && this.deployedForm.forms[i][`${group}`].schema[skey].type != 'time') {
                  let fieldSql = {
                    form: i,
                    group: group,
                    beforeAfter: 'During',
                    dbConnId: this.deployedForm.forms[i][`${group}`].schema[skey]['fieldConnId'],
                    sqlQuery: this.deployedForm.forms[i][`${group}`].schema[skey][ikey],
                    sqlVar: skey,
                    type: this.deployedForm.forms[i][`${group}`].schema[skey]['type']
                  };
                  
                  this.duringQueries.push(fieldSql);
                }
                // Set default values
                if(ikey == 'value') {
                  data[skey] = this.deployedForm.forms[i][`${group}`].schema[skey][ikey];
                }
                // Set title, subheader and paragraph values
                if(ikey == 'text') {
                  if(this.deployedForm.forms[i][`${group}`].schema[skey].type == 'subheader') {
                    let elemId = this.deployedForm.forms[i][`${group}`].schema[skey].id
                    document.getElementById(elemId).innerHTML = this.deployedForm.forms[i][`${group}`].schema[skey][ikey];
                  }
                }
              });
              
              if(skey in data) {
                // If we have a grid
                if(this.deployedForm.forms[i][`${group}`].schema[skey].type == 'array') {
                  let theItems = {};
                  let defaultItems = {};
                  let gridKeys = Object.keys(this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema);
                  gridKeys.forEach(gkey => {
                    if(typeof this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].value !== 'undefined') {
                      theItems[gkey] = this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].value;
                      defaultItems[gkey] = this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].value;
                    }else {
                      if(this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].type == 'wrap') {
                        // Checkbox
                        let gridCheckKeys = Object.keys(this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].schema);
                    
                        gridCheckKeys.forEach(ckey => {
                          if(typeof this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].schema[ckey] !== 'undefined') {
                            theItems[ckey] = this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].schema[ckey].value;
                            defaultItems[ckey] = this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].schema[ckey].value;
                          }
                        });
                      }
                    }

                    // Evaluate SQL fields
                    if(typeof this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].fieldSql !== 'undefined' && this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].fieldSql !== null && this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].fieldSql != '') {
                      let fieldSql = {
                        form: i,
                        group: group,
                        beforeAfter: 'During',
                        dbConnId: this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].fieldConnId,
                        sqlQuery: this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].fieldSql,
                        sqlVar: gkey,
                        type: this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].type,
                        isGrid: true,
                        theGrid: skey
                      };

                      this.duringQueries.push(fieldSql);
                    }
                  });

                  data[skey] = [{'items': []}];
                  this.formGrids[skey] = defaultItems;
                  this.setGridData();
                }
              }else {
                if(this.deployedForm.forms[i][`${group}`].schema[skey].type != 'subheader' && this.deployedForm.forms[i][`${group}`].schema[skey].type != 'file' && this.deployedForm.forms[i][`${group}`].schema[skey].type != 'btn' && !this.deployedForm.forms[i][`${group}`].schema[skey].spacer) {
                  if(this.deployedForm.forms[i][`${group}`].schema[skey].type == 'wrap') {
                    let checkKeys = Object.keys(this.deployedForm.forms[i][`${group}`].schema[skey].schema);
                    
                    checkKeys.forEach(ckey => {
                      if(typeof this.taskData[ckey] !== 'undefined') {
                        data[ckey] = this.taskData[ckey].value;
                      }else {
                        data[ckey] = false;
                      }
                    });
                  }else {
                    data[skey] = null;
                  }
                }

                // Dates & Times
                if(this.deployedForm.forms[i][`${group}`].schema[skey].type == 'date' || this.deployedForm.forms[i][`${group}`].schema[skey].type == 'time') {
                  // Evaluate SQL fields
                  if(typeof this.deployedForm.forms[i][`${group}`].schema[skey].fieldSql !== 'undefined' && this.deployedForm.forms[i][`${group}`].schema[skey].fieldSql !== null && this.deployedForm.forms[i][`${group}`].schema[skey].fieldSql != '') {
                    let fieldSql = {
                      form: i,
                      group: group,
                      beforeAfter: 'During',
                      dbConnId: this.deployedForm.forms[i][`${group}`].schema[skey].fieldConnId,
                      sqlQuery: this.deployedForm.forms[i][`${group}`].schema[skey].fieldSql,
                      sqlVar: skey,
                      type: this.deployedForm.forms[i][`${group}`].schema[skey].type,
                      isGrid: false
                    };
                    
                    this.singleQueries.push(fieldSql);
                  }
                }

                // Checkbox groups
                if(this.deployedForm.forms[i][`${group}`].schema[skey].type == 'array' && this.deployedForm.forms[i][`${group}`].schema[skey].arrayType == 'checkbox') {
                  let theItems = {};
                  let checkKeys = Object.keys(this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema);
                  checkKeys.forEach(ckey => {
                    theItems[ckey] = this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[ckey].value;
                  });

                  // Evaluate SQL fields
                  if(typeof this.deployedForm.forms[i][`${group}`].schema[skey].fieldSql !== 'undefined' && this.deployedForm.forms[i][`${group}`].schema[skey].fieldSql !== null && this.deployedForm.forms[i][`${group}`].schema[skey].fieldSql != '') {
                    let fieldSql = {
                      form: i,
                      group: group,
                      beforeAfter: 'During',
                      dbConnId: this.deployedForm.forms[i][`${group}`].schema[skey].fieldConnId,
                      sqlQuery: this.deployedForm.forms[i][`${group}`].schema[skey].fieldSql,
                      sqlVar: skey,
                      type: 'checkbox',
                      isGrid: false
                    };
                    
                    this.singleQueries.push(fieldSql);
                  }

                  data[skey] = [{'items': [theItems]}];
                }
                
                // Grids
                if(this.deployedForm.forms[i][`${group}`].schema[skey].type == 'array' && this.deployedForm.forms[i][`${group}`].schema[skey].arrayType == 'grid') {
                  let theItems = {};
                  let defaultItems = {};
                  let gridKeys = Object.keys(this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema);
                  gridKeys.forEach(gkey => {
                    if(typeof this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].value !== 'undefined') {
                      theItems[gkey] = this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].value;
                      defaultItems[gkey] = this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].value;
                    }else {
                      if(this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].type == 'wrap') {
                        // Checkbox
                        let gridCheckKeys = Object.keys(this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].schema);
                    
                        gridCheckKeys.forEach(ckey => {
                          if(typeof this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].schema[ckey] !== 'undefined') {
                            theItems[gkey] = this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].schema[ckey].value;
                            defaultItems[gkey] = this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].schema[ckey].value;
                          }
                        });
                      }
                    }

                    // Evaluate SQL fields
                    if(typeof this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].fieldSql !== 'undefined' && this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].fieldSql !== null && this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].fieldSql != '') {
                      let fieldSql = {
                        form: i,
                        group: group,
                        beforeAfter: 'During',
                        dbConnId: this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].fieldConnId,
                        sqlQuery: this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].fieldSql,
                        sqlVar: gkey,
                        type: this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[gkey].type,
                        isGrid: true,
                        theGrid: skey
                      };
                      this.duringQueries.push(fieldSql);
                    }
                  });
                  
                  data[skey] = [{'items': []}];
                  this.formGrids[skey] = defaultItems;
                  this.setGridData();
                }
              }
            });

            if(keys.length > 0) {
              keys.forEach((key) => {
                if(!processedKeys.includes(key)) {
                  if(typeof this.deployedForm.forms[i][`${group}`].schema[key] !== 'undefined') {
                    // Check for multi select
                    if(typeof this.deployedForm.forms[i][`${group}`].schema[key] == 'object') {
                      if(this.deployedForm.forms[i][`${group}`].schema[key].multiple && this.deployedForm.forms[i][`${group}`].schema[key].type != 'file') {
                        let str = this.taskData[key].value;
                        data[key] = str.split(',');
                      }else if(this.deployedForm.forms[i][`${group}`].schema[key].type == 'file') {  
                        if(this.caseFiles.length > 0) {
                          this.uploadedKeys.push(key);
                        }
                      }else if(this.deployedForm.forms[i][`${group}`].schema[key].type == 'array') {
                        data[key] = JSON.parse(this.taskData[key].value);
                      }else if(key in data) {
                        data[key] = this.taskData[key].value;
                      }else {
                        data[key] = this.taskData[key].value;
                      }
                    }else {
                      data[key] = this.taskData[key].value;
                    } 
                    processedKeys.push(key);
                  }else {
                    // Make sure this isn't a grid
                    let skip = false;
                    let gridKeys = Object.keys(this.formGrids);

                    gridKeys.forEach(gkey => {
                      if(key == gkey) {
                        skip = true;
                      }
                    });

                    if(!skip) {
                      data[key] = this.taskData[key].value;
                    }
                  }
                }
              });
            }

          }

        }

        // Initial run of fieldSql fields
        this.queryCount = this.beforeQueries.length + this.duringQueries.length + this.singleQueries.length;

        if(this.queryCount == 0) {
          this.runOnLoad = true;
        }

        for(let s = 0; s < this.singleQueries.length; s++) {
          this.executeFieldSql(this.singleQueries[s]);
        }

        for(let f = 0; f < this.duringQueries.length; f++) {
          this.executeFieldSql(this.duringQueries[f]);
        }

        this.$store.commit('UPDATE_ORIG_INSTANCE_ID', data.origProcessInstanceId);
        
        // Are we creating portal users?
        if(data.createPortalUser) {
          this.createPortalUser = true;
          this.createPortalUserNow();
        }
        
        return data;
      },
      gridAddRow(gname) {
        let newRow = {};
        let defaultKeys = Object.keys(this.formGrids[gname]);

        defaultKeys.forEach(dkey => {
          newRow[dkey] = this.formGrids[gname][dkey];
        });
        
        this.formModel[gname][0].items.push(newRow);

        let ref = this;
        setTimeout(function(){ 
          let gridDeleteRowBtns = document.querySelectorAll('.grid-delete-row');
          for(let i = 0; i < gridDeleteRowBtns.length; i++) {
            gridDeleteRowBtns[i].setAttribute('rowid', i);
          }
          ref.$store.commit('GRID_ROW_ADDED', true);
        }, 100);
      },
      gridDeleteRow(gname, rowid) {
        for(let i = 0; i < this.formModel[gname].length; i++) {
          for(let j = 0; j < this.formModel[gname][i].items.length; j++) {
            if(j == rowid) {
              this.formModel[gname][i].items.splice(j, 1);
            }
          }
        }
      },
      refreshTaskFiles() {
        this.$store.dispatch('getCaseFiles').then( () => {
          if(this.caseFiles.length > 0) {
            this.filesAvailable = true;
          }else {
            this.filesAvailable = false;
          }
        });
      },
      async downloadFile(item) {
        await this.$store.dispatch('downloadFile', item.ITEM_ID).then( () => {
          let e = document.createEvent('MouseEvents');
          let a = document.createElement('a');

          a.download = this.downloadFileName;
          a.href = this.downloadFileUrl;
          e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          a.dispatchEvent(e);
        });
      },
      openFile(item) {
        window.open(item.FILE_URL, '_blank');
      },
      deleteFile(item) {
        this.deleteFileTitle = this.$t('CASES.TASKS.VIEW_TASK.DELETE_FILE.TITLE');
        this.deleteFileText = this.$t('CASES.TASKS.VIEW_TASK.DELETE_FILE.DESC_1');
        this.deleteFileName = this.$t('CASES.TASKS.VIEW_TASK.DELETE_FILE.DESC_2') + ' ' + item.FILE_NAME;
        this.deleteFileId = item.ITEM_ID;
        this.deleteFileGroupId = item.MS_GROUP_ID;
        this.deleteLocalFile = item.IS_LOCAL;
        this.theFileName = item.FILE_NAME;
        this.deleteFileDialog = true;
      },
      async confirmDeleteFile() {
        this.deleteFileDialog = false;
        if(this.storageDetails.officeEnabled && !this.deleteLocalFile) {
          await this.$store.dispatch('getMSAuth').then( () => {
            let payload = {
              'fileId': this.deleteFileId,
              'groupId': this.deleteFileGroupId
            };
            this.$store.dispatch('deleteFile', payload).then( () => {
              this.updateLog('Document', 'Deleted', this.caseId, this.processName, this.taskName, 'Document ' + this.theFileName + ' deleted from OneDrive.');
            });
          });
        }
        if(this.storageDetails.localEnabled && this.deleteLocalFile) {
          this.$store.dispatch('deleteLocalFile', this.deleteFileId).then( () => {
            this.updateLog('Document', 'Deleted', this.caseId, this.processName, this.taskName, 'Document ' + this.theFileName + ' deleted from local storage.');
          });
        }
      },
      handleInput({obj}) {
        this.currentObj = obj;
        
        // Execute fieldSql fields
        if(obj.schema.type != 'text' && obj.schema.type != 'textarea' && obj.schema.type != 'file' && obj.schema.type != 'subheader') {
          for(let f = 0; f < this.duringQueries.length; f++) {
            this.executeFieldSql(this.duringQueries[f]);
          }
        }
        
        // Execute JS
        this.executeScript();
        
        this.validateObj(obj);
      },
      validateObj(obj) {
        this.validated = true;
        
        // Check for rules
        if(obj.schema.required && obj.schema.customRules && obj.schema.customRules.length > 0) {
          let ruleCheck = null;

          obj.schema.customRules.forEach((rule) => {            
            if(rule == 'requiredText') {
              ruleCheck = this.rules.requiredText(obj.value);
            }
            if(rule == 'requiredNumber') {
              ruleCheck = this.rules.requiredNumber(obj.value);
            }
            if(rule == 'requiredSelect') {
              ruleCheck = this.rules.requiredSelect(obj.value);
            }
            if(rule == 'requiredRadio') {
              ruleCheck = this.rules.requiredRadio(obj.value);
            }
            if(rule == 'requiredDate') {
              ruleCheck = this.rules.requiredDate(obj.value);
            }
            if(rule == 'requiredTime') {
              ruleCheck = this.rules.requiredTime(obj.value);
            }
            if(rule == 'requiredCheckbox') {
              ruleCheck = this.rules.requiredCheckbox(obj.value);
            }
            if(rule == 'requiredCheckboxAll') {
              ruleCheck = this.rules.requiredCheckboxAll(obj.value);
            }
            if(rule == 'requiredFile') {
              ruleCheck = this.rules.requiredFile(obj.value);

              if(ruleCheck == true) {
                if(this.uploadFileCount <= 0) {
                  ruleCheck = 'Please click Upload to proceed';
                }
              }
            }
            if(rule == 'requiredEmail') {
              ruleCheck = this.rules.requiredEmail(obj.value);
            }
            if(rule == 'validEmail') {
              if(obj.value) {
                ruleCheck = this.rules.validEmail(obj.value);
              }
            }

            if(ruleCheck != true && ruleCheck != null) {
              if(rule == 'requiredDate' || rule == 'requiredTime') {
                obj.schema.text.errorMessages = ruleCheck;
              } else {
                obj.schema.errorMessages = ruleCheck;
              }
              this.validated = false;
            }else {
              if(rule == 'requiredDate' || rule == 'requiredTime') {
                obj.schema.text.errorMessages = '';
              } else {
                obj.schema.errorMessages = '';
              }
            }
          });
        }

        if(!obj.schema.required && obj.schema.customRules && obj.schema.customRules.length > 0) {
          // Check for email validation when not required field
          let ruleCheck = null;

          obj.schema.customRules.forEach((rule) => { 
            if(rule == 'validEmail') {
              if(obj.value) {
                ruleCheck = this.rules.validEmail(obj.value);
              }
            }

            if(ruleCheck != true && ruleCheck != null) {
              obj.schema.errorMessages = ruleCheck;
              this.validated = false;
            }else {
              obj.schema.errorMessages = '';
            }
          });
        }

        // Check for checkbox group rules
        if(obj.schema.type == 'checkbox') {
          let i = this.s1 - 1;
        
          let numGroups = Object.keys(this.deployedForm.forms[i]).length;
          for(let j = 1; j < numGroups; j++) {
            let group = 'group' + j;

            let parent = obj.schema.parent;
            if(parent && this.deployedForm.forms[i][`${group}`].schema[parent] && this.deployedForm.forms[i][`${group}`].schema[parent].required) {
              let ruleCheck = null;
              let checkReqKey = '';
              this.deployedForm.forms[i][`${group}`].schema[parent].customRules.forEach((rule) => {
                if(rule == 'requiredCheckboxAll') {
                  const chkeys = Object.keys(this.currentData[parent][0].items[0]);
                  
                  chkeys.forEach((ckey) => {
                    if(checkReqKey == '') {
                      checkReqKey = ckey;
                    }

                    if(this.currentData[parent][0].items[0][ckey]) {
                      ruleCheck = true;
                    }
                  });

                  if(!ruleCheck) {
                    ruleCheck = 'At least one checkbox must be selected';
                  }
                }

                if(ruleCheck != true && ruleCheck != null) {
                  this.deployedForm.forms[i][`${group}`].schema[parent].schema.items.schema[checkReqKey].errorMessages = ruleCheck;
                  this.validated = false;
                }else {
                  this.deployedForm.forms[i][`${group}`].schema[parent].schema.items.schema[checkReqKey].errorMessages = '';
                }
              })
            }
          }
        }

        if(!this.validated) {
          this.formValid = false;
        }else {
          this.formValid = true;
        }
      },
      checkValidation(data) {
        this.validated = true;

        // Set the current form number
        let i = this.s1 - 1;
        
        let numGroups = Object.keys(this.deployedForm.forms[i]).length;
        for(let j = 1; j < numGroups; j++) {
          let group = 'group' + j;

          if(!this.deployedForm.forms[i][`${group}`].disabled && !this.deployedForm.forms[i][`${group}`].readonly ) {
            
            const schemaKeys = Object.keys(this.deployedForm.forms[i][`${group}`].schema);
            
            schemaKeys.forEach((skey) => {
              
              if(!this.deployedForm.forms[i][`${group}`].schema[skey].disabled && !this.deployedForm.forms[i][`${group}`].schema[skey].readonly) {
                
                if(this.uploadedKeys.indexOf(skey) == -1) {
                
                  const itemKeys = Object.keys(this.deployedForm.forms[i][`${group}`].schema[skey]);
                  
                  itemKeys.forEach((ikey) => {
                    // Check for rules
                    if(ikey == 'customRules') {
                      let ruleCheck = null;
                      this.deployedForm.forms[i][`${group}`].schema[skey][ikey].forEach((rule) => {
                        
                        let checkReqKey = '';
                        // Only check if field isn't hidden
                        if(!this.deployedForm.forms[i][`${group}`].schema[skey].hide) {
                          if(this.deployedForm.forms[i][`${group}`].schema[skey].required) {
                            if(rule == 'requiredText') {
                              ruleCheck = this.rules.requiredText(data[skey]);
                            }
                            if(rule == 'requiredNumber') {
                              ruleCheck = this.rules.requiredNumber(data[skey]);
                            }
                            if(rule == 'requiredSelect') {
                              ruleCheck = this.rules.requiredSelect(data[skey]);
                            }
                            if(rule == 'requiredRadio') {
                              ruleCheck = this.rules.requiredRadio(data[skey]);
                            }
                            if(rule == 'requiredDate') {
                              ruleCheck = this.rules.requiredDate(data[skey]);
                            }
                            if(rule == 'requiredTime') {
                              ruleCheck = this.rules.requiredTime(data[skey]);
                            }
                            if(rule == 'requiredCheckbox') {
                              ruleCheck = this.rules.requiredCheckbox(data[skey]);
                            }
                            if(rule == 'requiredCheckboxAll') {
                              // Make sure at least one option has been selected
                              const chkeys = Object.keys(data[skey][0].items[0]);

                              chkeys.forEach((ckey) => {
                                if(checkReqKey == '') {
                                  checkReqKey = ckey;
                                }

                                if(data[skey][0].items[0][ckey]) {
                                  ruleCheck = true;
                                }
                              });

                              if(!ruleCheck) {
                                ruleCheck = 'At least one checkbox must be selected';
                              }
                            }
                            if(rule == 'requiredFile') {
                              ruleCheck = this.rules.requiredFile(data[skey]);

                              if(ruleCheck == true) {
                                if(this.uploadFileCount <= 0) {
                                  ruleCheck = 'Please click Upload to proceed';
                                }
                              }
                            }
                            if(rule == 'requiredEmail') {
                              ruleCheck = this.rules.requiredEmail(data[skey]);
                            }
                            if(rule == 'validEmail') {
                              if(data[skey]) {
                                ruleCheck = this.rules.validEmail(data[skey]);
                              }
                            }
                            
                            if(ruleCheck != true && ruleCheck != null) {
                              if(rule == 'requiredDate' || rule == 'requiredTime') {
                                this.deployedForm.forms[i][`${group}`].schema[skey].text.errorMessages = ruleCheck;
                              }else if(rule == 'requiredCheckboxAll') {
                                this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[checkReqKey].errorMessages = ruleCheck;
                              } else {
                                this.deployedForm.forms[i][`${group}`].schema[skey].errorMessages = ruleCheck;
                              }
                              this.validated = false;
                            }else {
                              if(rule == 'requiredDate' || rule == 'requiredTime') {
                                this.deployedForm.forms[i][`${group}`].schema[skey].text.errorMessages = '';
                              }else if(rule == 'requiredCheckboxAll') {
                                this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[checkReqKey].errorMessages = '';
                              } else {
                                this.deployedForm.forms[i][`${group}`].schema[skey].errorMessages = '';
                              }
                            }
                          }else {
                            if(rule == 'validEmail') {
                              if(data[skey]) {
                                ruleCheck = this.rules.validEmail(data[skey]);
                              }

                              if(ruleCheck != true && ruleCheck != null) {
                                this.deployedForm.forms[i][`${group}`].schema[skey].errorMessages = ruleCheck;
                                this.validated = false;
                              }else {
                                this.deployedForm.forms[i][`${group}`].schema[skey].errorMessages = '';
                              }
                            }
                          }
                        }
                      });
                    }
                    if(ikey == 'schema') {
                      const groupItemKeys = Object.keys(this.deployedForm.forms[i][`${group}`].schema[skey].schema);

                      groupItemKeys.forEach((gikey) => {
                
                        if(this.uploadedKeys.indexOf(skey) == -1) {
                          const moreItemKeys = Object.keys(this.deployedForm.forms[i][`${group}`].schema[skey].schema[gikey]);
                      
                          moreItemKeys.forEach((mkey) => {
                            if(mkey == 'schema') {
                              
                              const moreSchemaKeys = Object.keys(this.deployedForm.forms[i][`${group}`].schema[skey].schema[gikey].schema);

                              moreSchemaKeys.forEach((mskey) => {
                                const evenMoreSchemaKeys = Object.keys(this.deployedForm.forms[i][`${group}`].schema[skey].schema[gikey].schema[mskey]);

                                evenMoreSchemaKeys.forEach((emskey) => {
                                  // Check for rules
                                  if(emskey == 'customRules') {
                                    let ruleCheck = null;

                                    this.deployedForm.forms[i][`${group}`].schema[skey].schema[gikey].schema[mskey][emskey].forEach((rule) => {
                                      // Only check if field isn't hidden
                                      if(!this.deployedForm.forms[i][`${group}`].schema[skey].hide) {
                                        if(this.deployedForm.forms[i][`${group}`].schema[skey].schema[gikey].schema[mskey].required) {
                                          if(rule == 'requiredCheckbox') {
                                            ruleCheck = this.rules.requiredCheckbox(data[skey][0].items[0][mskey]);
                                          }

                                          if(ruleCheck != true && ruleCheck != null) {
                                            this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[mskey].errorMessages = ruleCheck;
                                            this.validated = false;
                                          }else {
                                            this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[mskey].errorMessages = '';
                                          }
                                        }
                                      }
                                    });
                                  }
                                });
                              });
                            }
                          });

                        }
                      });
                    }
                  });
                }else {
                  this.deployedForm.forms[i][`${group}`].schema[skey].errorMessages = '';
                }
              }
            });
          }

        }
        
        if(!this.validated) {
          this.formValid = false;
        }else {
          this.formValid = true;
        }
      },
      continueForm(formData) {
        this.continueWasClicked = true;
        this.continueClicked = true;
        this.validateForm = true;
        this.continueFormData = formData;
        this.executeScript();
      },
      validate(formData) {
        if(this.validateForm) {
          this.checkValidation(formData);
          this.validateForm = false;
          this.continueFormData = [];
        }else {
          this.formValid = true;
        }
        
        if(this.formValid) {
          this.continueWasClicked = false;
          for(let i = 0; i < this.afterQueries.length; i++) {
            if(this.afterQueries[i].pageQueryNum == this.s1) {
              let runQuery = false;
              if(this.afterQueries[i].sqlRunIf != '') {
                let query = "let data = this.currentData;\n" + this.afterQueries[i].sqlRunIf;
                runQuery = eval(query);
              }else {
                runQuery = true;
              }
              // Runs on this page
              if(this.afterQueries[i].beforeAfter == 'After') {
                // Run now
                if(runQuery) {
                  this.executeSql(this.afterQueries[i]);
                }
              }
            }
          }
          
          if(this.goToPage > 0) {
            if(!this.continueClicked) {
              this.startPage = this.goToPage;
              this.currentPage = -1;
            }else {
              this.currentPage = this.s1;
            }
            this.s1 = this.goToPage;
          }else {
            this.currentPage = this.s1;
            this.s1 = this.s1 + 1;
          }
          
          for(let j = 0; j < this.afterQueries.length; j++) {
            if(this.afterQueries[j].pageQueryNum == this.s1) {
              let runQuery = false;
              if(this.afterQueries[j].sqlRunIf != '') {
                let query = "let data = this.currentData;\n" + this.afterQueries[j].sqlRunIf;
                runQuery = eval(query);
              }else {
                runQuery = true;
              }
              // Runs on this page
              if(this.afterQueries[j].beforeAfter == 'Before') {
                // Run now
                if(runQuery) {
                  this.executeSql(this.afterQueries[j]);
                }
              }
            }
          }

          // Execute field queries
          for(let f = 0; f < this.duringQueries.length; f++) {
            this.executeFieldSql(this.duringQueries[f]);
          }
        }else {
          this.continueClicked = false;
        }
      },
      async uploadFileToSP(fileData) {
        this.$store.commit('UPLOAD_SUCCESSFUL', false);
        this.$store.commit('UPLOADED_FILE_DATA', []);
        await this.$store.dispatch('getMSAuth').then( () => {
          this.$store.dispatch('uploadFilesToMS', fileData);
        });
      },
      encodeImgtoBase64(file, callback) {
        var reader = new FileReader();
        reader.onloadend = callback;
        reader.readAsDataURL(file);
      },
      generateRandomId() {
        // Declare all characters
        let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let length = 34;

        // Generate ID
        let str = '';
        for (let i = 0; i < length; i++) {
            str += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        return str;
      },
      uploadFile(item) {
        // Get the upload field
        let targetField = item.target.parentElement.getAttribute('linkedto');
        let formData = this.formModel;

        const keys = Object.keys(formData);

        keys.forEach((key) => {
          if(key == targetField) {
            // Check file sizes
            let sizeError = false;
            let fileInError = '';
            for(let s = 0; s < formData[key].length; s++) {
              let size = ((formData[key][s].size/1024)/1024).toFixed(4); // MB
              if(size > 60) {
                sizeError = true;
                fileInError = formData[key][s].name;
                break;
              }
            }
            if(!sizeError) {
              // Update schema
              this.updateSchema(key);
              // File upload (Office 365)
              if(this.storageDetails.officeEnabled) {
                this.uploadFileCount = formData[key].length;
                this.uploadFileToSP(formData[key]).then( () => {
                  this.uploadKey = key;
                  this.uploadedKeys.push(key);
                  this.checkValidation(formData);
                });
              }
              // Local file storage
              if(this.storageDetails.localEnabled) {
                let ref = this;
                this.uploadFileCount = formData[key].length;

                for(let i = 0; i < formData[key].length; i++) {
                  let id = this.generateRandomId();
                  
                  this.encodeImgtoBase64(formData[key][i], function(base64) {
                    let fileName = formData[key][i].name;
                    let mimeType = formData[key][i].type;
                    let fileSize = formData[key][i].size;

                    // Strip out the base64 test at the start
                    let index = base64.target.result.indexOf('base64');
                    index += 7;
                    let fileData = base64.target.result.slice(index);

                    let payload = {
                      'storageType': 'local',
                      'id': id,
                      'name': fileName,
                      'mimeType': mimeType,
                      'size': fileSize,
                      'fileData': fileData,
                      'created': new Date()
                    }
                    ref.$store.dispatch('uploadFileData', payload).then( () => {
                      ref.uploadKey = key;
                      ref.uploadedKeys.push(key);
                      ref.checkValidation(formData);
                    });
                  });
                }
              }
            }else {
              this.snackFileError(fileInError);
            }
          }
        });
      },
      updateSchema(key) {
        // Set the current form number
        let i = this.s1 - 1;
        
        let numGroups = Object.keys(this.deployedForm.forms[i]).length;
        for(let j = 1; j < numGroups; j++) {
          let group = 'group' + j;

          if(!this.deployedForm.forms[i][`${group}`].disabled && !this.deployedForm.forms[i][`${group}`].readonly) {
            const schemaKeys = Object.keys(this.deployedForm.forms[i][`${group}`].schema);
            let uploadBtn = key + 'Btn';
            
            schemaKeys.forEach((skey) => {
              if(skey == uploadBtn) {
                // Set loading animation on upload button
                if(this.deployedForm.forms[i][`${group}`].schema[skey].loading) {
                  this.deployedForm.forms[i][`${group}`].schema[skey].loading = false;
                }else {
                  this.deployedForm.forms[i][`${group}`].schema[skey].loading = true;
                }
              }
            });
          }
        }
      },
      updateSchemaForm(pageNum) {
        // Set the current form number
        let i = pageNum;
        
        if(this.deployedForm.forms[i]) {
          let numGroups = Object.keys(this.deployedForm.forms[i]).length;
          for(let j = 1; j < numGroups; j++) {
            let group = 'group' + j;

            if(!this.deployedForm.forms[i][`${group}`].disabled && !this.deployedForm.forms[i][`${group}`].readonly) {
              const schemaKeys = Object.keys(this.deployedForm.forms[i][`${group}`].schema);
              
              schemaKeys.forEach((skey) => {
                if(this.deployedForm.forms[i][`${group}`].schema[skey].arrayType != 'checkbox' && this.deployedForm.forms[i][`${group}`].schema[skey].type != 'btn') {
                  // Update required fields (except checkboxes)
                  if(this.deployedForm.forms[i][`${group}`].schema[skey].required) {
                    this.deployedForm.forms[i][`${group}`].schema[skey].prependIcon = 'mdi-star-outline';

                    if(this.deployedForm.forms[i][`${group}`].schema[skey].type == 'date' || this.deployedForm.forms[i][`${group}`].schema[skey].type == 'time') {
                      this.deployedForm.forms[i][`${group}`].schema[skey].text.prependIcon = 'mdi-star-outline';
                    }

                    if('class' in this.deployedForm.forms[i][`${group}`].schema[skey]) {
                      if(this.deployedForm.forms[i][`${group}`].schema[skey].class.includes('pl-8')) {
                        this.deployedForm.forms[i][`${group}`].schema[skey].class = this.deployedForm.forms[i][`${group}`].schema[skey].class.replace('pl-8', '');
                      }

                      if('text' in this.deployedForm.forms[i][`${group}`].schema[skey]) {
                        if('class' in this.deployedForm.forms[i][`${group}`].schema[skey].text) {
                          if(this.deployedForm.forms[i][`${group}`].schema[skey].type == 'date' || this.deployedForm.forms[i][`${group}`].schema[skey].type == 'time') {
                            this.deployedForm.forms[i][`${group}`].schema[skey].text.class = this.deployedForm.forms[i][`${group}`].schema[skey].text.class.replace('pl-8', 'pl-0');
                          }
                        }
                      }
                    }
                  }else {
                    this.deployedForm.forms[i][`${group}`].schema[skey].prependIcon = '';
                    this.deployedForm.forms[i][`${group}`].schema[skey].errorMessages = '';

                    if(this.deployedForm.forms[i][`${group}`].schema[skey].type == 'date' || this.deployedForm.forms[i][`${group}`].schema[skey].type == 'time') {
                      this.deployedForm.forms[i][`${group}`].schema[skey].text.prependIcon = '';
                      this.deployedForm.forms[i][`${group}`].schema[skey].text.errorMessages = '';
                    }
                    
                    if('class' in this.deployedForm.forms[i][`${group}`].schema[skey]) {
                      if(!this.deployedForm.forms[i][`${group}`].schema[skey].class.includes('pl-8')) {
                        
                        if(this.deployedForm.forms[i][`${group}`].schema[skey].type == 'date' || this.deployedForm.forms[i][`${group}`].schema[skey].type == 'time') {
                          this.deployedForm.forms[i][`${group}`].schema[skey].text.class = 'pl-8';
                        }else {
                          this.deployedForm.forms[i][`${group}`].schema[skey].class += ' pl-8';
                        }
                      }
                    }
                  }

                  // Update hidden fields
                  if('hide' in this.deployedForm.forms[i][`${group}`].schema[skey]) {
                    if(this.deployedForm.forms[i][`${group}`].schema[skey].hide) {
                      if(this.deployedForm.forms[i][`${group}`].schema[skey].type == 'date' || this.deployedForm.forms[i][`${group}`].schema[skey].type == 'time') {
                        if('class' in this.deployedForm.forms[i][`${group}`].schema[skey]) {
                          this.deployedForm.forms[i][`${group}`].schema[skey].class += ' hidden-spacer';
                        }
                        if('class' in this.deployedForm.forms[i][`${group}`].schema[skey].text) {
                          this.deployedForm.forms[i][`${group}`].schema[skey].text.class += ' hidden-spacer';
                        }
                      }else if(this.deployedForm.forms[i][`${group}`].schema[skey].type == 'file') {
                        if('class' in this.deployedForm.forms[i][`${group}`].schema[skey]) {
                          this.deployedForm.forms[i][`${group}`].schema[skey].class += ' hidden-spacer';
                        }

                        let btnName = skey + "Btn";
                        if('class' in this.deployedForm.forms[i][`${group}`].schema[btnName]) {
                          this.deployedForm.forms[i][`${group}`].schema[btnName].class += ' hidden-spacer';
                        }
                      }else {
                        if('class' in this.deployedForm.forms[i][`${group}`].schema[skey]) {
                          this.deployedForm.forms[i][`${group}`].schema[skey].class += ' hidden-spacer';
                        }
                      }
                    }else {
                      if(this.deployedForm.forms[i][`${group}`].schema[skey].type == 'date' || this.deployedForm.forms[i][`${group}`].schema[skey].type == 'time') {
                        if('class' in this.deployedForm.forms[i][`${group}`].schema[skey]) {
                          if(this.deployedForm.forms[i][`${group}`].schema[skey].class.includes('hidden-spacer')) {
                            this.deployedForm.forms[i][`${group}`].schema[skey].class = this.deployedForm.forms[i][`${group}`].schema[skey].class.replaceAll('hidden-spacer', '');
                          }
                        }
                        if('class' in this.deployedForm.forms[i][`${group}`].schema[skey].text) {
                          if(this.deployedForm.forms[i][`${group}`].schema[skey].text.class.includes('hidden-spacer')) {
                            this.deployedForm.forms[i][`${group}`].schema[skey].text.class = this.deployedForm.forms[i][`${group}`].schema[skey].text.class.replaceAll('hidden-spacer', '');
                          }
                        }
                      }else if(this.deployedForm.forms[i][`${group}`].schema[skey].type == 'file') {
                        if('class' in this.deployedForm.forms[i][`${group}`].schema[skey]) {
                          if(this.deployedForm.forms[i][`${group}`].schema[skey].class.includes('hidden-spacer')) {
                            this.deployedForm.forms[i][`${group}`].schema[skey].class = this.deployedForm.forms[i][`${group}`].schema[skey].class.replaceAll('hidden-spacer', '');
                          }
                        }

                        let btnName = skey + "Btn";
                        if('class' in this.deployedForm.forms[i][`${group}`].schema[btnName]) {
                          if(this.deployedForm.forms[i][`${group}`].schema[btnName].class.includes('hidden-spacer')) {
                            this.deployedForm.forms[i][`${group}`].schema[btnName].class = this.deployedForm.forms[i][`${group}`].schema[btnName].class.replaceAll('hidden-spacer', '');
                          }
                        }
                      }else {
                        if('class' in this.deployedForm.forms[i][`${group}`].schema[skey]) {
                          if(this.deployedForm.forms[i][`${group}`].schema[skey].class.includes('hidden-spacer')) {
                            this.deployedForm.forms[i][`${group}`].schema[skey].class = this.deployedForm.forms[i][`${group}`].schema[skey].class.replaceAll('hidden-spacer', '');
                          }
                        }
                      }
                    }
                  }
                }

                if(this.deployedForm.forms[i][`${group}`].schema[skey].arrayType == 'checkbox') {

                  let markFirst = false;
                  let allChecksReq = false;
                  let checkboxHidden = false;
                  let checkLabel = skey + '_label';

                  if('hide' in this.deployedForm.forms[i][`${group}`].schema[skey]) {
                    if(this.deployedForm.forms[i][`${group}`].schema[skey].hide) {
                      checkboxHidden = true;
                      if('class' in this.deployedForm.forms[i][`${group}`].schema[skey]) {
                        this.deployedForm.forms[i][`${group}`].schema[skey].class += ' hidden-spacer';
                        this.deployedForm.forms[i][`${group}`].schema[checkLabel].class += ' hidden-spacer';
                      }
                    }else {
                      checkboxHidden = false;
                      if('class' in this.deployedForm.forms[i][`${group}`].schema[skey]) {
                        if(this.deployedForm.forms[i][`${group}`].schema[skey].class.includes('hidden-spacer')) {
                          this.deployedForm.forms[i][`${group}`].schema[skey].class = this.deployedForm.forms[i][`${group}`].schema[skey].class.replaceAll('hidden-spacer', '');
                          this.deployedForm.forms[i][`${group}`].schema[checkLabel].class = this.deployedForm.forms[i][`${group}`].schema[checkLabel].class.replaceAll('hidden-spacer', '');
                        }
                      }
                    }
                  }
                  
                  if(!checkboxHidden) {
                    if(this.deployedForm.forms[i][`${group}`].schema[skey].required) {
                      markFirst = true;
                      allChecksReq = true;
                    }

                    const checkKeys = Object.keys(this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema);

                    checkKeys.forEach((chkey) => {
                      if(markFirst && allChecksReq) {
                        this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[chkey].prependIcon = 'mdi-star-outline';
                        markFirst = false;
                      }

                      if(this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[chkey].required) {
                        this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[chkey].prependIcon = 'mdi-star-outline';

                        if('class' in this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[chkey]) {
                          if(this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[chkey].class.includes('pl-8')) {
                            this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[chkey].class = this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[chkey].class.replace('pl-8', '');
                          }
                        }
                      } else {
                        if(!allChecksReq) {
                          this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[chkey].prependIcon = '';

                          if('class' in this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[chkey]) {
                            if(!this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[chkey].class.includes('pl-8')) {
                              this.deployedForm.forms[i][`${group}`].schema[skey].schema.items.schema[chkey].class += ' pl-8';
                            }
                          }
                        }
                      }
                    });
                  }
                }
              });
            }
          }

          let prep = document.getElementsByClassName('v-input__icon--prepend');
          for(let pre = 0; pre < prep.length; pre++) {
            prep[pre].setAttribute('style', '');
          }
        }
      },
      saveForm(formData, action) {
        let payload = {};
        let vars = {};
        let varName = '';
        let varType = '';
        let value = '';

        const keys = Object.keys(formData);

        keys.forEach((key) => {

            if(formData[key] == null) {
              formData[key] = "";
            }
            
            varName = key;

            // Check for file
            if(Array.isArray(formData[key])) {
              if(formData[key][0] instanceof File) {
                // Do nothing
              }else {
                // Do something with grids/db data
                if(key in this.formGrids) {
                  value = JSON.stringify(formData[key]);
                  varType = 'string';
                  vars[varName] = { 'value': value, 'type': varType };
                }else {
                  // Checkbox
                  value = JSON.stringify(formData[key]);
                  varType = 'string';
                  vars[varName] = { 'value': value, 'type': varType };
                }
              }
            }else {
              if(typeof formData[key] == 'object') {
                
                // Is it an array?
                if(Array.isArray(formData[key])) {
                  value = formData[key].toString();
                  varType = 'string';
                }else {
                  value = formData[key].val;
                  varType = 'string';
                }
              }else {
                value = formData[key];
                varType = typeof formData[key];
              }

              if(typeof formData[key] == 'number') {
                if(Number.isInteger(value)) {
                  varType = 'integer';
                }else {
                  varType = 'double';
                }
              }

              vars[varName] = { 'value': value, 'type': varType };
            }

            // Clear for next pass
            varName = '';
            varType = '';
            value = '';
        });

        payload['modifications'] = vars;
        let data = {
          'payload': payload,
          'instanceId': this.instanceId
        }
        
        this.$store.dispatch('saveTask', data).then( () => {
          if(action == 'close') {
            this.stopAutoCheck();
          }
          if(action == 'reload') {
            this.$store.dispatch('getTaskData', this.instanceId).then( async () => {
              this.formModel = this.loadData();
              await this.$store.dispatch('getCaseFiles').then( () => {
                if(this.caseFiles.length > 0) {
                  this.filesAvailable = true;
                }
              });

              if(this.runOnLoad) {
                if(this.extScript != '' && this.extScript !== null) {
                  this.currentData = this.formModel;
                  this.executeScript();
                  // Check for goToPage
                  if(this.goToPage > 0) {
                    this.s1 = this.goToPage;
                  }
                }
                this.runOnLoad = false;
              }

            });
          }
        });
      },
      submitForm(formData) {
        this.loading = true;
        this.submitting = true;
        this.executeScript();

        let ref = this;
        setTimeout(function(){ 
          ref.checkValidation(formData);

          if(ref.formValid && !ref.cancelSubmit) {

            let payload = {};
            let vars = {};
            let varName = '';
            let varType = '';
            let value = '';

            // Portal user vars
            let portalUserFirstname = '';
            let portalUserLastname = '';
            let portalUserEmail = '';
            let targetPortal = '';
            let groupId = '';
            let groupName = '';

            const keys = Object.keys(formData);

            keys.forEach((key) => {

                if(formData[key] == null) {
                  formData[key] = "";
                }
                
                varName = key;

                // Check for file
                if(Array.isArray(formData[key])) {
                  if(formData[key][0] instanceof File) {
                    // Do nothing
                  }else {
                    // Do something with grids/db data
                    if(key in ref.formGrids) {
                      value = JSON.stringify(formData[key]);
                      varType = 'string';
                      vars[varName] = { 'value': value, 'type': varType };
                    }else {
                      // Checkbox
                      value = JSON.stringify(formData[key]);
                      varType = 'string';
                      vars[varName] = { 'value': value, 'type': varType };
                    }
                  }
                }else {
                  if(typeof formData[key] == 'object') {

                    // Is it an array?
                    if(Array.isArray(formData[key])) {
                      value = formData[key].toString();
                      varType = 'string';
                    }else {
                      value = formData[key].val;
                      varType = 'string';
                    }
                  }else {
                    value = formData[key];
                    varType = typeof formData[key];

                    // Set portal user vars
                    if(key == 'portalUserFirstname') {
                      portalUserFirstname = formData[key];
                    }
                    if(key == 'portalUserLastname') {
                      portalUserLastname = formData[key];
                    }
                    if(key == 'portalUserEmail') {
                      portalUserEmail = formData[key];
                    }
                    if(key == 'portalUsername') {
                      ref.portalUsername = formData[key];
                    }
                    if(key == 'targetPortal') {
                      targetPortal = formData[key];
                    }
                    if(key == 'groupId') {
                      groupId = formData[key];
                    }
                    if(key == 'groupName') {
                      groupName = formData[key];
                    }
                  }

                  if(typeof formData[key] == 'number') {
                    if(Number.isInteger(value)) {
                      varType = 'integer';
                    }else {
                      varType = 'double';
                    }
                  }

                  vars[varName] = { 'value': value, 'type': varType };
                }

                // Clear for next pass
                varName = '';
                varType = '';
                value = '';
            });

            // Include portal user details if required
            if(ref.createPortalUser) {

              if(ref.portalPassword == '') {
                ref.portalPassword = ref.userPassGen('password');
              }

              let payload = {
                'profile': {
                  'id': ref.portalUsername,
                  'firstName': portalUserFirstname,
                  'lastName': portalUserLastname,
                  'email': portalUserEmail
                },
                'credentials': {
                  'password': ref.portalPassword
                },
                'targetPortal': targetPortal
              };
              ref.$store.dispatch('createPortalUser', payload).then( () => {
                ref.updateLog('Admin', 'Created', ref.caseId, ref.processName, ref.taskName, 'Portal user ' + ref.portalUsername + ' created.');

                let rolePayload = {
                  'id': 'portalUser',
                  'userId': ref.portalUsername
                };
                ref.$store.dispatch('addUserToRole', rolePayload).then( () => {
                  ref.updateLog('Admin', 'Created', ref.caseId, ref.processName, ref.taskName, 'Portal user ' + ref.portalUsername + ' added to role portalUser.');
                })
                if(groupId != '') {
                  let groupPayload = {
                    'id': groupId,
                    'name': groupName,
                    'type': 'Workflow',
                    'tenant': targetPortal
                  };
                  ref.$store.dispatch('addGroup', groupPayload).then( () => {
                    ref.updateLog('Admin', 'Created', ref.caseId, ref.processName, ref.taskName, 'Group ' + groupName + ' created on tenant ' + targetPortal + '.');

                    let usersToAdd = [];
                    usersToAdd.push(ref.portalUsername);
                    
                    let userPayload = {
                      'groupId': groupId,
                      'users': usersToAdd
                    }
                    
                    ref.$store.dispatch('addUsersToGroup', userPayload).then( () => {
                      ref.updateLog('Admin', 'Added', 'Users ' + usersToAdd.toString() + ' added to group ' + groupId + '.');
                    });
                  })
                }
              });

              vars['portalUsername'] = { 'value': ref.portalUsername, 'type': 'String' };
              vars['portalPassword'] = { 'value': ref.portalPassword, 'type': 'String' };
            }
            vars['createPortalUser'] = { 'value': false, 'type': 'Boolean' };

            let runQuery = false;
            for(let i = 0; i < ref.afterQueries.length; i++) {
              if(ref.afterQueries[i].pageQueryNum == ref.s1) {
                if(ref.afterQueries[i].sqlRunIf != '') {
                  let query = "let data = ref.currentData;\n" + ref.afterQueries[i].sqlRunIf;
                  runQuery = eval(query);
                }else {
                  runQuery = true;
                }
                // Runs on this page
                if(ref.afterQueries[i].beforeAfter == 'After') {
                  // Run now
                  if(runQuery) {
                    ref.executeSql(ref.afterQueries[i]);
                  }
                }
              }
            }

            payload['variables'] = vars;
            payload['withVariablesInReturn'] = true;
            let data = {
              'payload': payload,
              'taskId': ref.taskId
            }

            if(!runQuery) {
              ref.$store.dispatch('completeTask', data).then( () => {
                ref.stopAutoCheck();
              });
            }else {
              ref.completeTaskData = data;
              ref.runCompleteTask = true;
            }
          }else {
            ref.loading = false;
            ref.submitting = false;
          }
        }, 1500);
      },
      snackFileError(fileName) {
        this.snack = true;
        this.snackTimeout = 10000;
        this.snackColor = 'error';
        this.snackText = fileName + ' is larger than 60MB. Files were not uploaded.';
      },
      snackErrorMessage () {
        this.isErrorSnack = true;
        this.snack = true;
        this.snackTimeout = 0;
        this.snackColor = 'error';
        this.snackText = this.errorMessage + '. Please contact your System Administrator.';
      },
      updateLog(cat, op, caseId, process, task, msg) {
        let dt = new Date();
        let dateTime = new Intl.DateTimeFormat('en-GB', 
          {
            day: 'numeric',
            month: 'numeric', 
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false
          }).format(dt);

        let logData = {
          'category': cat,
          'userId': this.$store.state.currentUser,
          'caseId': caseId,
          'processName': process,
          'taskName': task,
          'operation': op,
          'msg': msg,
          'dateTime': dateTime,
        };
        this.$store.dispatch('updateOpLog', logData);
      }
    }
  }
</script>

<style>
  #form-base .v-card__title,
  #form-base .v-card__subtitle {
    padding-left: 0;
  }
  #form-base .v-input__control {
    padding-right: 10px;
  }
  .custom-margin {
    margin: auto;
    margin-top: 10px;
  }
  button.v-icon.mdi-star-outline,
  i.v-icon.mdi-star-outline {
    color: #ff5252;
    font-size: 16px;
  }
  .v-input .v-label {
    line-height: 15px !important;
  }
  .v-text-field--outlined .v-label {
    top: 10px;
  }
  .v-input__prepend-outer {
    margin-top: 10px !important;
  }
  .v-input input,
  .v-input .v-select__selections {
    padding-left: 10px !important;
  }
  #form-base .v-label.v-label--active,
  #form-base .grid-element .v-label.v-label--active {
    margin-top: -10px;
  }
  .v-textarea .v-input__slot {
    min-height: 122px !important;
  }
  .v-input--radio-group .v-input__slot {
    border: none !important;
  }
  .v-radio .v-label {
    position: inherit !important;
  }
  .v-input--radio-group--row .v-input--radio-group__input > .v-label {
    padding-right: 20px !important;
  }
  .v-input--radio-group--column .v-input--radio-group__input > .v-label {
    position: inherit !important;
  }
  .v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 46px !important;
  }
  .v-select > .v-input__control > .v-input__slot {
    height: 52px !important;
  }
  .v-input--selection-controls {
    margin-top: 12px;
  }
  .file-uploader > span {
    height: 100%;
    width: 130%;
  }
  .hidden-spacer {
    display: none;
  }
  .v-sheet.theme--light:focus::before { opacity: 0; }
  #form-base .v-input--is-readonly .v-input__slot,
  #form-base .v-input--is-disabled .v-input__slot {
    background-color: #eee !important;
    border: 1px solid grey !important;
  }
  #form-base .theme--light.v-input--is-disabled input,
  #form-base .theme--light.v-select .v-select__selection--disabled,
  #form-base .v-label.v-label--is-disabled.theme--light,
  #form-base .v-label.theme--light {
    color: #000000a9 !important;
  }
</style>